import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ef7888a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "visually-hidden visually-hidden_card",
  role: "button"
}
const _hoisted_2 = {
  class: "departure-card__main",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "departure-card__text" }
const _hoisted_4 = { class: "departure-card__title" }
const _hoisted_5 = { class: "departure-card__info" }
const _hoisted_6 = {
  key: 0,
  class: "departure-card__cancelled align-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelled", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "departure-card__platform align-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_display_time = _resolveComponent("a-display-time")!
  const _component_a_card_icon = _resolveComponent("a-card-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "departure-card",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.accessibleText), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_display_time, {
        class: "departure-card__time",
        "actual-time": _ctx.actualTime,
        "scheduled-time": _ctx.scheduledTime
      }, null, 8, ["actual-time", "scheduled-time"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
          'departure-card__signs',
          _ctx.cancelled && 'departure-card__signs--cancelled'
        ])
      }, [
        (_ctx.cancelled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.platform || '--'), 1)
            ])),
        _createVNode(_component_a_card_icon, {
          "icon-type": _ctx.ICON_TYPE.NEXT
        }, null, 8, ["icon-type"])
      ], 2)
    ])
  ]))
}